import QueryService from "../../../services/QueryService";
import { StatusModel } from "../../models/Status";
import { IQueryStatusRepository } from "../../ports/status/IQueryStatusRepository";

export class StatusQueryService
  extends QueryService<StatusModel>
  implements IQueryStatusRepository
{
  public constructor(
    public baseURL: string,
    public pathname: string,
  ) {
    super(baseURL, pathname);
  }

  public async findBySlug(slug: string): Promise<StatusModel | null> {
    try {
      const response = await this.search({
        search: {
          filters: [{ field: "slug", operator: "=", value: slug }],
        },
      });
      return response.data?.length > 0 ? response.data[0] : null;
    } catch (error) {
      console.error(`Error finding demand status by slug ${slug}:`, error);
      return null;
    }
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const statusQueryService = new StatusQueryService(BASE_URL, "request_status");

export { statusQueryService };
